// tslint:disable
export var TransactionType;
(function (TransactionType) {
    // Cleared
    TransactionType[TransactionType["CLEARED"] = 1] = "CLEARED";
    // Rejected
    TransactionType[TransactionType["REJECTED"] = 2] = "REJECTED";
    // ADD_FUNDS_TRANS
    TransactionType[TransactionType["ADD_FUNDS_TRANS"] = 3] = "ADD_FUNDS_TRANS";
    // REFUND_TRANS
    TransactionType[TransactionType["REFUND_TRANS"] = 4] = "REFUND_TRANS";
    // PRE_AUTHORIZATION_REQUEST
    TransactionType[TransactionType["PRE_AUTHORIZATION_REQUEST"] = 5] = "PRE_AUTHORIZATION_REQUEST";
    // PRE_AUTHORIZATION_RESPONSE
    TransactionType[TransactionType["PRE_AUTHORIZATION_RESPONSE"] = 6] = "PRE_AUTHORIZATION_RESPONSE";
    // FORCE_POST_PRE_AUTHORIZATION
    TransactionType[TransactionType["FORCE_POST_PRE_AUTHORIZATION"] = 7] = "FORCE_POST_PRE_AUTHORIZATION";
    // FORCE_POST_PRE_AUTH_DUPLICATE
    TransactionType[TransactionType["FORCE_POST_PRE_AUTH_DUPLICATE"] = 8] = "FORCE_POST_PRE_AUTH_DUPLICATE";
    // FORCE_POST_PRE_AUTH_RESPONSE
    TransactionType[TransactionType["FORCE_POST_PRE_AUTH_RESPONSE"] = 9] = "FORCE_POST_PRE_AUTH_RESPONSE";
    // NORMAL_AUTHORIZATION_REQUEST
    TransactionType[TransactionType["NORMAL_AUTHORIZATION_REQUEST"] = 10] = "NORMAL_AUTHORIZATION_REQUEST";
    // STATEMENT_PRINT_REQUEST
    TransactionType[TransactionType["STATEMENT_PRINT_REQUEST"] = 11] = "STATEMENT_PRINT_REQUEST";
    // NORMAL_AUTHORIZATION_RESPONSE
    TransactionType[TransactionType["NORMAL_AUTHORIZATION_RESPONSE"] = 12] = "NORMAL_AUTHORIZATION_RESPONSE";
    // STATEMENT_PRINT_RESPONSE
    TransactionType[TransactionType["STATEMENT_PRINT_RESPONSE"] = 13] = "STATEMENT_PRINT_RESPONSE";
    // FORCE_POST_MESSAGE
    TransactionType[TransactionType["FORCE_POST_MESSAGE"] = 14] = "FORCE_POST_MESSAGE";
    // FORCE_POST_DUPLICATE
    TransactionType[TransactionType["FORCE_POST_DUPLICATE"] = 15] = "FORCE_POST_DUPLICATE";
    // FORCE_POST_ADVICE_RESPONSE
    TransactionType[TransactionType["FORCE_POST_ADVICE_RESPONSE"] = 16] = "FORCE_POST_ADVICE_RESPONSE";
    // FROM_HOST_MAINT_MESSAGE
    TransactionType[TransactionType["FROM_HOST_MAINT_MESSAGE"] = 17] = "FROM_HOST_MAINT_MESSAGE";
    // REVERSAL_MESSAGE
    TransactionType[TransactionType["REVERSAL_MESSAGE"] = 18] = "REVERSAL_MESSAGE";
    // REVERSAL_DUPLICATE
    TransactionType[TransactionType["REVERSAL_DUPLICATE"] = 19] = "REVERSAL_DUPLICATE";
    // REVERSAL_ADVICE_RESPONSE
    TransactionType[TransactionType["REVERSAL_ADVICE_RESPONSE"] = 20] = "REVERSAL_ADVICE_RESPONSE";
    // COPY_REQUEST_RESPONSE
    TransactionType[TransactionType["COPY_REQUEST_RESPONSE"] = 21] = "COPY_REQUEST_RESPONSE";
    // NETWORK_MANAGEMENT_MESSAGE
    TransactionType[TransactionType["NETWORK_MANAGEMENT_MESSAGE"] = 22] = "NETWORK_MANAGEMENT_MESSAGE";
    // NETWORK_MANAGEMENT_RESPONSE
    TransactionType[TransactionType["NETWORK_MANAGEMENT_RESPONSE"] = 23] = "NETWORK_MANAGEMENT_RESPONSE";
    // LATE_MULTI_ACCOUNT_MESSAGE
    TransactionType[TransactionType["LATE_MULTI_ACCOUNT_MESSAGE"] = 24] = "LATE_MULTI_ACCOUNT_MESSAGE";
    // DDA_WITHDRAWAL
    TransactionType[TransactionType["DDA_WITHDRAWAL"] = 25] = "DDA_WITHDRAWAL";
    // MM_WITHDRAWAL
    TransactionType[TransactionType["MM_WITHDRAWAL"] = 26] = "MM_WITHDRAWAL";
    // CHECK_GUARANTEE
    TransactionType[TransactionType["CHECK_GUARANTEE"] = 27] = "CHECK_GUARANTEE";
    // DDA_DEPOSIT
    TransactionType[TransactionType["DDA_DEPOSIT"] = 28] = "DDA_DEPOSIT";
    // MM_DEPOSIT
    TransactionType[TransactionType["MM_DEPOSIT"] = 29] = "MM_DEPOSIT";
    // DDA_PURCHASE
    TransactionType[TransactionType["DDA_PURCHASE"] = 30] = "DDA_PURCHASE";
    // DDA_PURCHASE_CASHBACK
    TransactionType[TransactionType["DDA_PURCHASE_CASHBACK"] = 31] = "DDA_PURCHASE_CASHBACK";
    // DDA_PURCHASE_REFUND
    TransactionType[TransactionType["DDA_PURCHASE_REFUND"] = 32] = "DDA_PURCHASE_REFUND";
    // DDA_BALANCE_INQUIRY_OR_DDA_SAV_BALANCE_INQUIRY
    TransactionType[TransactionType["DDA_BALANCE_INQUIRY_OR_DDA_SAV_BALANCE_INQUIRY"] = 33] = "DDA_BALANCE_INQUIRY_OR_DDA_SAV_BALANCE_INQUIRY";
    // DDA_CURRENT_BAL_INQUIRY
    TransactionType[TransactionType["DDA_CURRENT_BAL_INQUIRY"] = 34] = "DDA_CURRENT_BAL_INQUIRY";
    // TSYS_DDA_CURRENT_BAL_INQ
    TransactionType[TransactionType["TSYS_DDA_CURRENT_BAL_INQ"] = 35] = "TSYS_DDA_CURRENT_BAL_INQ";
    // VISA_DEBIT_ADJUSTMENT
    TransactionType[TransactionType["VISA_DEBIT_ADJUSTMENT"] = 36] = "VISA_DEBIT_ADJUSTMENT";
    // OUTBOUND_ACH_CREDIT
    TransactionType[TransactionType["OUTBOUND_ACH_CREDIT"] = 37] = "OUTBOUND_ACH_CREDIT";
    // OUTBOUND_ACH_DEBIT
    TransactionType[TransactionType["OUTBOUND_ACH_DEBIT"] = 38] = "OUTBOUND_ACH_DEBIT";
    // DDA_PREAUTHORIZATION
    TransactionType[TransactionType["DDA_PREAUTHORIZATION"] = 39] = "DDA_PREAUTHORIZATION";
    // PAYMENT_FROM_DDA
    TransactionType[TransactionType["PAYMENT_FROM_DDA"] = 40] = "PAYMENT_FROM_DDA";
    // PAYMENT_FROM_DDA_TO_CC
    TransactionType[TransactionType["PAYMENT_FROM_DDA_TO_CC"] = 41] = "PAYMENT_FROM_DDA_TO_CC";
    // PAYMENT_FROM_SAV_TO_CC
    TransactionType[TransactionType["PAYMENT_FROM_SAV_TO_CC"] = 42] = "PAYMENT_FROM_SAV_TO_CC";
    // PAYMENT_FROM_MONEY
    TransactionType[TransactionType["PAYMENT_FROM_MONEY"] = 43] = "PAYMENT_FROM_MONEY";
    // BILL_PAYMENT
    TransactionType[TransactionType["BILL_PAYMENT"] = 44] = "BILL_PAYMENT";
    // DDA_TRANSFER
    TransactionType[TransactionType["DDA_TRANSFER"] = 45] = "DDA_TRANSFER";
    // DDA_TRANSFER_FROM_SAV_OR_SAVINGS_TRANSFER_TO_DDA
    TransactionType[TransactionType["DDA_TRANSFER_FROM_SAV_OR_SAVINGS_TRANSFER_TO_DDA"] = 46] = "DDA_TRANSFER_FROM_SAV_OR_SAVINGS_TRANSFER_TO_DDA";
    // DDA_TRANSFER_TO_SAV_OR_SAVINGS_TRANSFER_FROM_DDA
    TransactionType[TransactionType["DDA_TRANSFER_TO_SAV_OR_SAVINGS_TRANSFER_FROM_DDA"] = 47] = "DDA_TRANSFER_TO_SAV_OR_SAVINGS_TRANSFER_FROM_DDA";
    // DDA_TRANSFER_TO_MM
    TransactionType[TransactionType["DDA_TRANSFER_TO_MM"] = 48] = "DDA_TRANSFER_TO_MM";
    // MM_TRANSFER_TO_DDA
    TransactionType[TransactionType["MM_TRANSFER_TO_DDA"] = 49] = "MM_TRANSFER_TO_DDA";
    // MM_TRANSFER_TO_SAV
    TransactionType[TransactionType["MM_TRANSFER_TO_SAV"] = 50] = "MM_TRANSFER_TO_SAV";
    // SAV_TRANSFER_TO_MM
    TransactionType[TransactionType["SAV_TRANSFER_TO_MM"] = 51] = "SAV_TRANSFER_TO_MM";
    // CC_TRANSFER_TO_DDA
    TransactionType[TransactionType["CC_TRANSFER_TO_DDA"] = 52] = "CC_TRANSFER_TO_DDA";
    // VISA_DDA_WITHDRAWAL
    TransactionType[TransactionType["VISA_DDA_WITHDRAWAL"] = 53] = "VISA_DDA_WITHDRAWAL";
    // VISA_REPRESENTMENT
    TransactionType[TransactionType["VISA_REPRESENTMENT"] = 54] = "VISA_REPRESENTMENT";
    // VISA_DDA_CASH_ADVANCE
    TransactionType[TransactionType["VISA_DDA_CASH_ADVANCE"] = 55] = "VISA_DDA_CASH_ADVANCE";
    // VISA_DDA_PURCHASE
    TransactionType[TransactionType["VISA_DDA_PURCHASE"] = 56] = "VISA_DDA_PURCHASE";
    // VISA_DDA_PURCHASE_REFUND
    TransactionType[TransactionType["VISA_DDA_PURCHASE_REFUND"] = 57] = "VISA_DDA_PURCHASE_REFUND";
    // VISA_DDA_TRANSFER
    TransactionType[TransactionType["VISA_DDA_TRANSFER"] = 58] = "VISA_DDA_TRANSFER";
    // VISA_DDA_TRANSFER_FR_SAV_OR_VISA_SAV_TRANSFER_TO_DDA
    TransactionType[TransactionType["VISA_DDA_TRANSFER_FR_SAV_OR_VISA_SAV_TRANSFER_TO_DDA"] = 59] = "VISA_DDA_TRANSFER_FR_SAV_OR_VISA_SAV_TRANSFER_TO_DDA";
    // VISA_DDA_TRANSFER_TO_SAV_OR_SAV_VISA_CREDIT_TRANSACTION_OR_VISA_SAV_TRANSFER_FR_DDA
    TransactionType[TransactionType["VISA_DDA_TRANSFER_TO_SAV_OR_SAV_VISA_CREDIT_TRANSACTION_OR_VISA_SAV_TRANSFER_FR_DDA"] = 60] = "VISA_DDA_TRANSFER_TO_SAV_OR_SAV_VISA_CREDIT_TRANSACTION_OR_VISA_SAV_TRANSFER_FR_DDA";
    // VISA_INTERACTIVE
    TransactionType[TransactionType["VISA_INTERACTIVE"] = 61] = "VISA_INTERACTIVE";
    // MC_REPRESENTMENT
    TransactionType[TransactionType["MC_REPRESENTMENT"] = 62] = "MC_REPRESENTMENT";
    // MC_DDA_PURCHASE
    TransactionType[TransactionType["MC_DDA_PURCHASE"] = 63] = "MC_DDA_PURCHASE";
    // MC_DDA_PURCHASE_INTRNTL
    TransactionType[TransactionType["MC_DDA_PURCHASE_INTRNTL"] = 64] = "MC_DDA_PURCHASE_INTRNTL";
    // MC_CASH_ADVANCE
    TransactionType[TransactionType["MC_CASH_ADVANCE"] = 65] = "MC_CASH_ADVANCE";
    // MC_DDA_PURCHASE_REFUND
    TransactionType[TransactionType["MC_DDA_PURCHASE_REFUND"] = 66] = "MC_DDA_PURCHASE_REFUND";
    // MC_DDA_PURCH_REFD_INTRNTL
    TransactionType[TransactionType["MC_DDA_PURCH_REFD_INTRNTL"] = 67] = "MC_DDA_PURCH_REFD_INTRNTL";
    // MC_DDA_TRANSFER
    TransactionType[TransactionType["MC_DDA_TRANSFER"] = 68] = "MC_DDA_TRANSFER";
    // MC_DDA_TRANSFER_FR_SAV_OR_MC_SAV_TRANSFER_TO_DDA
    TransactionType[TransactionType["MC_DDA_TRANSFER_FR_SAV_OR_MC_SAV_TRANSFER_TO_DDA"] = 69] = "MC_DDA_TRANSFER_FR_SAV_OR_MC_SAV_TRANSFER_TO_DDA";
    // MC_DDA_TRANSFER_TO_SAV_OR_MC_SAV_TRANSFER_FR_DDA_OR_SAV_MC_CREDIT_TRANSACTION
    TransactionType[TransactionType["MC_DDA_TRANSFER_TO_SAV_OR_MC_SAV_TRANSFER_FR_DDA_OR_SAV_MC_CREDIT_TRANSACTION"] = 70] = "MC_DDA_TRANSFER_TO_SAV_OR_MC_SAV_TRANSFER_FR_DDA_OR_SAV_MC_CREDIT_TRANSACTION";
    // BAL_ADJ_CREDIT_TRANSACTION
    TransactionType[TransactionType["BAL_ADJ_CREDIT_TRANSACTION"] = 71] = "BAL_ADJ_CREDIT_TRANSACTION";
    // BAL_ADJ_DEBIT_TRANSACTION
    TransactionType[TransactionType["BAL_ADJ_DEBIT_TRANSACTION"] = 72] = "BAL_ADJ_DEBIT_TRANSACTION";
    // SAV_VISA_DEBIT_TRANSACTION_OR_VISA_SAV_WITHDRAWAL
    TransactionType[TransactionType["SAV_VISA_DEBIT_TRANSACTION_OR_VISA_SAV_WITHDRAWAL"] = 73] = "SAV_VISA_DEBIT_TRANSACTION_OR_VISA_SAV_WITHDRAWAL";
    // SAV_MC_DEBIT_TRANSACTION_OR_MC_SAV_WITHDRAWAL
    TransactionType[TransactionType["SAV_MC_DEBIT_TRANSACTION_OR_MC_SAV_WITHDRAWAL"] = 74] = "SAV_MC_DEBIT_TRANSACTION_OR_MC_SAV_WITHDRAWAL";
    // SAV_ACH_CREDIT_TRANSACTION
    TransactionType[TransactionType["SAV_ACH_CREDIT_TRANSACTION"] = 75] = "SAV_ACH_CREDIT_TRANSACTION";
    // SAV_ACH_DEBIT_TRANSACTION
    TransactionType[TransactionType["SAV_ACH_DEBIT_TRANSACTION"] = 76] = "SAV_ACH_DEBIT_TRANSACTION";
    // SAVINGS_WITHDRAWAL
    TransactionType[TransactionType["SAVINGS_WITHDRAWAL"] = 77] = "SAVINGS_WITHDRAWAL";
    // SAVINGS_DEPOSIT
    TransactionType[TransactionType["SAVINGS_DEPOSIT"] = 78] = "SAVINGS_DEPOSIT";
    // SAVINGS_PURCHASE
    TransactionType[TransactionType["SAVINGS_PURCHASE"] = 79] = "SAVINGS_PURCHASE";
    // SAVINGS_PURCHASE_CASHBACK
    TransactionType[TransactionType["SAVINGS_PURCHASE_CASHBACK"] = 80] = "SAVINGS_PURCHASE_CASHBACK";
    // DDA_NON_CASH_DISP
    TransactionType[TransactionType["DDA_NON_CASH_DISP"] = 81] = "DDA_NON_CASH_DISP";
    // SAV_NON_CASH_DISP
    TransactionType[TransactionType["SAV_NON_CASH_DISP"] = 82] = "SAV_NON_CASH_DISP";
    // SAVINGS_PURCHASE_REFUND
    TransactionType[TransactionType["SAVINGS_PURCHASE_REFUND"] = 83] = "SAVINGS_PURCHASE_REFUND";
    // SAV_CURRENT_BAL_INQUIRY
    TransactionType[TransactionType["SAV_CURRENT_BAL_INQUIRY"] = 84] = "SAV_CURRENT_BAL_INQUIRY";
    // MM_CURRENT_BAL_INQUIRY
    TransactionType[TransactionType["MM_CURRENT_BAL_INQUIRY"] = 85] = "MM_CURRENT_BAL_INQUIRY";
    // SAV_WITHDRAWAL_LIMIT_INQUIRY_OR_SAV_PREAUTHORIZATION
    TransactionType[TransactionType["SAV_WITHDRAWAL_LIMIT_INQUIRY_OR_SAV_PREAUTHORIZATION"] = 86] = "SAV_WITHDRAWAL_LIMIT_INQUIRY_OR_SAV_PREAUTHORIZATION";
    // PAYMENT_FROM_SAVINGS
    TransactionType[TransactionType["PAYMENT_FROM_SAVINGS"] = 87] = "PAYMENT_FROM_SAVINGS";
    // SAVINGS_TRANSFER
    TransactionType[TransactionType["SAVINGS_TRANSFER"] = 88] = "SAVINGS_TRANSFER";
    // VISA_SAV_TRANSFER
    TransactionType[TransactionType["VISA_SAV_TRANSFER"] = 89] = "VISA_SAV_TRANSFER";
    // MC_SAV_TRANSFER
    TransactionType[TransactionType["MC_SAV_TRANSFER"] = 90] = "MC_SAV_TRANSFER";
    // CASH_ADVANCE
    TransactionType[TransactionType["CASH_ADVANCE"] = 91] = "CASH_ADVANCE";
    // PAYMENT_TO_CREDIT_CARD
    TransactionType[TransactionType["PAYMENT_TO_CREDIT_CARD"] = 92] = "PAYMENT_TO_CREDIT_CARD";
    // CREDIT_PURCHASE
    TransactionType[TransactionType["CREDIT_PURCHASE"] = 93] = "CREDIT_PURCHASE";
    // CREDIT_PURCHASE_REFUND
    TransactionType[TransactionType["CREDIT_PURCHASE_REFUND"] = 94] = "CREDIT_PURCHASE_REFUND";
    // CREDIT_BALANCE_INQUIRY
    TransactionType[TransactionType["CREDIT_BALANCE_INQUIRY"] = 95] = "CREDIT_BALANCE_INQUIRY";
    // CREDIT_PREAUTHORIZATION
    TransactionType[TransactionType["CREDIT_PREAUTHORIZATION"] = 96] = "CREDIT_PREAUTHORIZATION";
    // PAYMENT_FROM_CREDIT_CARD
    TransactionType[TransactionType["PAYMENT_FROM_CREDIT_CARD"] = 97] = "PAYMENT_FROM_CREDIT_CARD";
    // PAYMENT_ENCLOSED
    TransactionType[TransactionType["PAYMENT_ENCLOSED"] = 98] = "PAYMENT_ENCLOSED";
    // MESSAGE_ENCLOSED
    TransactionType[TransactionType["MESSAGE_ENCLOSED"] = 99] = "MESSAGE_ENCLOSED";
    // EXPIRED_FUNDS_DEBIT
    TransactionType[TransactionType["EXPIRED_FUNDS_DEBIT"] = 100] = "EXPIRED_FUNDS_DEBIT";
    // EXPIRED_FUNDS_CREDIT
    TransactionType[TransactionType["EXPIRED_FUNDS_CREDIT"] = 101] = "EXPIRED_FUNDS_CREDIT";
    // CREDIT_TRANS
    TransactionType[TransactionType["CREDIT_TRANS"] = 102] = "CREDIT_TRANS";
    // DEBIT_TRANS
    TransactionType[TransactionType["DEBIT_TRANS"] = 103] = "DEBIT_TRANS";
    // SITE_C2C_XFER_DR
    TransactionType[TransactionType["SITE_C2C_XFER_DR"] = 104] = "SITE_C2C_XFER_DR";
    // PERSON_TO_PERSON_DR
    TransactionType[TransactionType["PERSON_TO_PERSON_DR"] = 105] = "PERSON_TO_PERSON_DR";
    // PERSON_TO_PERSON_CR
    TransactionType[TransactionType["PERSON_TO_PERSON_CR"] = 106] = "PERSON_TO_PERSON_CR";
    // MERCHANT_SERVICE_CHARGE
    TransactionType[TransactionType["MERCHANT_SERVICE_CHARGE"] = 107] = "MERCHANT_SERVICE_CHARGE";
    // DECLINE_SERVICE_CHARGE
    TransactionType[TransactionType["DECLINE_SERVICE_CHARGE"] = 108] = "DECLINE_SERVICE_CHARGE";
    // SERVICE_CHARGE_REV
    TransactionType[TransactionType["SERVICE_CHARGE_REV"] = 109] = "SERVICE_CHARGE_REV";
    // SAV_INTERBANK_TRANSFER
    TransactionType[TransactionType["SAV_INTERBANK_TRANSFER"] = 110] = "SAV_INTERBANK_TRANSFER";
    // POS_ACTIVATE_CARD
    TransactionType[TransactionType["POS_ACTIVATE_CARD"] = 111] = "POS_ACTIVATE_CARD";
    // CARD_TO_CARD_XFER_DDA_WD
    TransactionType[TransactionType["CARD_TO_CARD_XFER_DDA_WD"] = 112] = "CARD_TO_CARD_XFER_DDA_WD";
    // CARD_TO_CARD_XFER_DDA_DP
    TransactionType[TransactionType["CARD_TO_CARD_XFER_DDA_DP"] = 113] = "CARD_TO_CARD_XFER_DDA_DP";
    // Unknown
    TransactionType[TransactionType["UNKNOWN"] = 113] = "UNKNOWN";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map